<template>
    <div class="container-fluid calendar-screen">
        <div class="row">
            <div :class="{'col-8': calendarAside, 'col-12': !calendarAside}">
                <calendar
                    @dayClick="dayClicked"
                    ref="calendar"
                    @eventClick="eventClicked"
                    @dateChange="onDateChange"
                    :initial-date="calendarDateParam"
                    :focus-event-id="focusEventId"
                    :open-event="openEvent"
                    :show-jobs="true"
                    :show-all-staff="true"
                />
            </div>
            <div
                class="col-4"
                v-show="calendarAside"
            >
                <calendar-form
                    v-if="openEvent"
                    @saved="onSaved"
                    :event="openEvent"
                    @cancel="showForm = false"
                />
            </div>
        </div>
    </div>
</template>
<script>
import Calendar from "../../CalendarComponent.vue";
import moment from "moment";
import CalendarForm from "./Form.vue";
import Auth from '../../../services/AuthService';
import {editableTypes, isEventEditable} from "../../../include/Calendar";
export default {
    components: {
        Calendar,
        CalendarForm,
    },
    data() {
        return {
            showForm: false,
            loading: false,
            showJobs: true,
            openEvent: null,
        };
    },
    computed: {
        calendarAside() {
            return this.showForm && Auth.user.admin_access;
        },
        calendarDateParam () {
            return this.$route.query.date || null;
        },
        focusEventId () {
            return this.$route.query.event || null;
        },
    },
    created () {
        if (!this.$route.query.date) {
            this.onDateChange(moment(), {keepEvent: true});
        }
    },
    methods: {
        dayClicked(day) {
            this.showForm = true;
            const startDate = day.clone().startOf('day');
            this.openEvent = {
                type: editableTypes[0],
                start_at: startDate,
                end_at: startDate.clone().endOf('day'),
                user_id: null,
                status: 'Pending',
            };
        },

        eventClicked(clickEvent) {
            const event = { ...clickEvent };
            if (!isEventEditable(event)) {
                this.openEvent = undefined;
                this.showForm = false;
                return;
            }

            this.openEvent = {
                ...event,
                start_at: moment(event.start_at),
                end_at: moment(event.end_at),
            };
            this.showForm = true;
        },

        onSaved() {
            this.openEvent = undefined;
            this.$refs.calendar.refresh();
        },

        onDateChange (date, options) {
            const formatted = date.format('YYYY-MM-DD');
            const keepEvent = options && options.keepEvent;
            if (this.$route.query.date === formatted && (keepEvent || !this.$route.query.event)) {
                return;
            }
            const query = {
                ...this.$route.query,
                date: formatted,
            };
            if (!keepEvent) {
                delete query.event;
            }
            this.$router.replace({ query });
        },
    },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/office/calendar/IndexComponent.vue